module.exports = __webpack_public_path__ + "static/media/loading-cat.44ee415b.gif";